import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';

// Shown when checkout needs a wedding date to compute the auto-end date.
export const WeddingDateDialog = ({ open, onOpenChange, onSubmit, busy }) => {
  const [date, setDate] = useState('');
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="wedding-date-dialog" className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">When's the big day?</DialogTitle>
          <DialogDescription>
            Your plan ends automatically 90 days after your wedding, so you never have to remember to cancel.
          </DialogDescription>
        </DialogHeader>
        <input data-testid="wedding-date-input" type="date" value={date} onChange={(e) => setDate(e.target.value)}
               className="w-full px-3 py-2.5 rounded-xl border border-[#EFE3D8] text-sm focus:outline-none focus:border-[#7B2C3B]" />
        <button data-testid="wedding-date-continue" disabled={!date || busy} onClick={() => onSubmit({ date })}
                className="w-full py-3 rounded-full bg-[#7B2C3B] text-white text-sm disabled:opacity-40">Continue to checkout</button>
        <button data-testid="wedding-date-unknown" disabled={busy} onClick={() => onSubmit({ unknown: true })}
                className="text-xs text-[#7B2C3B] underline">We haven't picked a date yet (billing ends 18 months after signup instead)</button>
      </DialogContent>
    </Dialog>
  );
};

export default WeddingDateDialog;
